import { bestNavOffset } from './Scrollto';

const ACTIVE = 'is-active';

/*
 * The Best template's Contents card: which entry is highlighted.
 *
 * Nothing is highlighted on a fresh load. The template used to mark the first
 * entry active, which told the reader they were inside a section they had not
 * chosen and that is usually off screen. An entry lights up only once it is
 * the one that was followed -- clicked here, or already in the URL when the
 * page opened, so a shared link arrives with its own section marked.
 */
export default {
  init() {
    const links = document.querySelectorAll('.best-nav__link');

    if (!links.length) {
      return;
    }

    const setActive = hash => {
      links.forEach(link => {
        link.classList.toggle(
          ACTIVE,
          !!hash && link.getAttribute('href') === hash
        );
      });
    };

    const { hash } = window.location;

    setActive(hash);

    /*
     * A page opened straight on an anchor arrives by the browser's own jump,
     * which puts the heading at the very top of the viewport -- behind the
     * fixed header. Redo the scroll through the offset the Contents links use,
     * so arriving by link and arriving by URL end on the same line.
     */
    let target = null;

    if (hash) {
      links.forEach(link => {
        if (link.getAttribute('href') === hash) {
          target = document.querySelector(hash);
        }
      });
    }

    if (target) {
      // Deferred by a task: Chrome re-applies the fragment itself once the
      // last resources land, which is after `load` -- correcting it inside
      // this handler would simply be scrolled over again.
      window.setTimeout(() => {
        window.scrollTo(
          0,
          target.getBoundingClientRect().top +
            window.pageYOffset -
            bestNavOffset()
        );
      }, 0);
    }

    links.forEach(link => {
      link.addEventListener('click', () => {
        setActive(link.getAttribute('href'));
      });
    });

    // Back and forward move between anchors without a click.
    window.addEventListener('hashchange', () => {
      setActive(window.location.hash);
    });
  }
};
